import { getState } from '/bb/state.js';

function visibilityHandler() {
  const s = getState();
  if (document.visibilityState === 'visible') {
    s.session.pageFocusCount += 1;
  }
}

function orientationHandler() {
  const s = getState();
  s.session.orientationChangeCount += 1;
}

let attached = false;

export function attach() {
  if (attached || typeof document === 'undefined') return;
  document.addEventListener('visibilitychange', visibilityHandler, { passive: true, capture: false });
  if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
    if ('orientation' in window) {
      window.addEventListener('orientationchange', orientationHandler, { passive: true, capture: false });
    } else if (typeof screen !== 'undefined' && screen.orientation && typeof screen.orientation.addEventListener === 'function') {
      screen.orientation.addEventListener('change', orientationHandler, { passive: true });
    }
  }
  attached = true;
}

export function detach() {
  if (!attached || typeof document === 'undefined') return;
  document.removeEventListener('visibilitychange', visibilityHandler);
  if (typeof window !== 'undefined' && typeof window.removeEventListener === 'function') {
    window.removeEventListener('orientationchange', orientationHandler);
    if (typeof screen !== 'undefined' && screen.orientation && typeof screen.orientation.removeEventListener === 'function') {
      try {
        screen.orientation.removeEventListener('change', orientationHandler);
      } catch (e) {
        /* ignore */
      }
    }
  }
  attached = false;
}
